import { useMutation } from "@tanstack/react-query"
import { fetchUpdateAssingTo, fetchupdateToKanbanBoard } from "../../utils/apiUtils"
import { queryClient } from "../../App"
import { loadUsers } from "../../utils/optionLoaderUtils"
import { useState } from "react"
import { AsyncPaginate } from "react-select-async-paginate"
import { customStyles } from "../../utils/styleUtils"
import ReactJson from "react-json-view"

const TicketDetails = ({ data, queryKey, updateAssigToMutation }) => {

    const onSuccess = (data, variables) => {

        if (!data) return

        queryClient.setQueryData(queryKey, (currentDagta => {
            let oldData = JSON.parse(JSON.stringify(currentDagta))
            if (oldData) {

                for (let i = 0; i < oldData.pages.length; i++) {
                    let page = oldData.pages[i];

                    page.Items = page.Items.map((item) => {
                        if (item.pk === variables.pk && item.sk === variables.sk) {

                            item = { ...item, ...data }
                            console.log({ item })
                        }
                        return item;
                    });

                    oldData.pages[i] = page;
                }
            }
            return oldData
        }));
    }

    const updateToKanbanBoardHandler = async (body) => {
        console.log('add to kanban', body)
        return await fetchupdateToKanbanBoard({
            pk: body.pk,
            sk: body.sk,
            isInKanban: !body.isInKanban,
            lane: 'todo'
        })
    }

    // const updateAssigToMutation = useMutation({
    //     mutationFn: async (body) => {
    //         return await fetchUpdateAssingTo({
    //             pk: body.pk,
    //             sk: body.sk,
    //             assignTo: body.assignTo
    //         })
    //     },
    //     onSuccess,
    //     onError: (err) => {
    //         console.log(err)
    //         // setError(err?.response?.data?.message || err.message)
    //     }
    // })

    const mutation = useMutation({
        mutationFn: updateToKanbanBoardHandler,
        onSuccess,
        onError: (err) => {
            console.log(err)
            // setError(err?.response?.data?.message || err.message)
        }
    })

    return <div >Ticket details
        <br />  <br />
        {/* {mutation.status} */}
        {/* {updateAssigToMutation?.status} */}
        <ReactJson
            style={{ padding: "1rem" }}
            src={data || ""}
            name={false}
            collapsed={1}
            collapseStringsAfterLength={150}
            displayDataTypes={false}
            displayObjectSize={false}
            sortKeys={true}
        />
        <p>{data?.pk}</p>
        <p>{data?.isInKanban ? 'isInKanban' : 'is in backlog'}</p>
        <button className="btn"
            onClick={() => mutation.mutate(data)}>
            {data.isInKanban ? 'Remove from board' : 'Add to board'}
        </button>

        <br />
        <label>Assign to</label>
        <AsyncPaginate
            placeholder={"Select a User"}
            className="react-select-container large-input"
            classNamePrefix={"react-select"}
            debounceTimeout={300}
            value={{ value: data.assignTo, label: data.assignTo }}
            loadOptions={loadUsers}
            onChange={(val) => {
                console.log({ val })
                updateAssigToMutation.mutate({
                    pk: data.pk,
                    sk: data.sk,
                    assignTo: val.value
                })

            }}
            styles={customStyles}
            isClearable
        />
    </div>
}

export default TicketDetails